import { render, staticRenderFns } from "./commissionDetail.vue?vue&type=template&id=28702f2a&scoped=true"
import script from "./commissionDetail?vue&type=script&lang=js&external"
export * from "./commissionDetail?vue&type=script&lang=js&external"
import style0 from "./commissionDetail.vue?vue&type=style&index=0&id=28702f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28702f2a",
  null
  
)

export default component.exports